import { render, staticRenderFns } from "./Debtors.vue?vue&type=template&id=8e2c5284&"
import script from "./Debtors.vue?vue&type=script&lang=js&"
export * from "./Debtors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports